import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, SubmissionError } from 'redux-form';

import request from 'common/Api';
import { FORMS } from 'common/Constants';
import * as actions from 'common/SearchStore/SearchActions';
import { base64Encode } from 'utils/strings';
import isEmail from 'validator/lib/isEmail';
import Search from './Search';

const onSubmit = ({ bookingNumber }, dispatch) => {
  const isEmailEntered = isEmail(bookingNumber);
  const decodedEmail = isEmailEntered ? base64Encode(bookingNumber.toLowerCase()) : bookingNumber;
  const endpoint = `/csp/bookings/${!isEmailEntered ? bookingNumber : `email/${decodedEmail}`}`;
  return dispatch(
    request({
      method: 'GET',
      url: endpoint,
    }),
  )
    .then((bookingData) => {
      const { bookingData: bookingInfo } = bookingData;
      const allBookings = [];
      allBookings.push(bookingData);
      const bookingBody = isEmailEntered ? bookingInfo : allBookings;
      if (!bookingBody?.[0]?.passengers?.length) {
        throw new Error('Passengers missing from search result.');
      }
      dispatch(actions.setPassengerUpdateStatus());
      dispatch(actions.receiveBooking(bookingBody));
      return Promise.resolve();
    })

    .catch((error) => {
      const formError = {};
      const { response } = error;
      switch (response?.status) {
        case 503: {
          formError._error =
            'My Viking Journey is currently down for maintenance and will be back soon. <br /> Please try again later.';
          break;
        }
        case 409: {
          formError._error = 'Booking Cancelled';
          formError.type = 'status-message';
          break;
        }
        case 405: {
          formError._error = 'This email is for a TA. <br /> Please enter the guest email address.';
          formError.type = 'status-message';
          break;
        }
        case 404: {
          const bookingNumberError =
            'No booking number found. <br /> Please verify the booking number is correct and try again.';
          const emailError =
            'No MVJ account has been created for this email. <br /> Please have the guest create a new account.';

          formError._error = isEmailEntered ? emailError : bookingNumberError;
          formError.type = 'status-message';
          break;
        }
        default: {
          formError._error = 'No search results found. <br /> Please try again.';
        }
      }
      return Promise.reject(new SubmissionError(formError));
    });
};

const mapStateToProps = (state) => {
  return {
    booking: state.booking,
  };
};

const mapDispatchToProps = (dispatch) => ({
  clearBookingFormData: () => dispatch(actions.clearBookingData()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORMS.SEARCH,
    onSubmit,
  }),
)(Search);
